/* eslint-disable no-use-before-define */
/* eslint-disable react/void-dom-elements-no-children */

import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Link } from "react-router-dom";
import Button from "../../../shared/components/button/button";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";
import { SelectOptions } from "../../../shared/interfaces/components/form.interface";
import {
  MapStateToPropsSignup,
  SignUpProps,
  SignUpState,
} from "../../../shared/interfaces/components/signup.interface";
import * as actions from "../../../store/signup/actions";
import nexumLogo from "../../../assets/nexumLogo.png";
import InputMultiSelectComponent from "../../../shared/components/forms/multi-select/multi-select-input";

import Sidebar from "../../../shared/components/sidebar";
import Navbar from "../../../shared/components/navbar";
import { Product } from "../../../shared/interfaces/model/product.interface";
import "../../../../styles/singupPage/singupPopup.scss";
import Button2 from "../../../shared/components/button/Button2";
import {
  Building2Icon,
  CodeIcon,
  Combine,
  LucideBuilding,
  MailIcon,
  SaveIcon,
  UsersIcon,
} from "lucide-react";
import MainLayout from "../../../shared/components/MainLayout";
import Loader from "../../../shared/components/loader/Loader";

class SignUp extends Component<SignUpProps, SignUpState> {
  constructor(props: SignUpProps) {
    super(props);

    this.state = {
      organizationName: "",
      organizationEmail: "",
      productsSelected: [],
      tierSelected: { id: "", value: "" },
      numberEmployees: 0,
      subscriptionDuration: { id: "", value: "" },
      products: [],
      companyName: "",
      VAT: "",
      destinationCode: "",
      pec: "",
      isEmail: false,
      isFormValid: false,
      errors: {},
      showPopup: false,
      name: "",
      email: "",
      surname: "",
      dateOfBirth: "",
      city: "",
      province: "",
      fiscalCode: "",
      address: "",
      phoneNumber: "",
      isUser: false,
      showSuccessPopup: false,
      isLoading: false,
    };
  }

  componentDidMount(): void {
    this.setProducts();
  }

  componentDidUpdate(prevProps: SignUpProps) {
    if (this.props.isSignupOk) {
      setTimeout(() => {
        this.setState({ isLoading: false });
        this.props.location("/private/tenantList");
        window.location.reload();
      }, 5000);
    }
    if (this.props.productList !== prevProps.productList) {
      this.setProducts();
    }
  }

  setProducts() {
    if (
      this.props.productList !== undefined &&
      this.props.productList.length > 0
    ) {
      const productsFromApi = this.props.productList.map(
        (product: Product) => ({
          id: product.appCode,
          value: product.name,
        })
      );
      this.setState({ products: productsFromApi });
    }
  }

  refOrganization: React.RefObject<HTMLInputElement> = React.createRef();

  refEmail: React.RefObject<HTMLInputElement> = React.createRef();

  // refProduct: React.RefObject<HTMLInputElement> = React.createRef();

  // refTier: React.RefObject<HTMLInputElement> = React.createRef();

  refUser: React.RefObject<HTMLInputElement> = React.createRef();

  refCompanyName: React.RefObject<HTMLInputElement> = React.createRef();

  refVAT: React.RefObject<HTMLInputElement> = React.createRef();

  refDestinationCode: React.RefObject<HTMLInputElement> = React.createRef();

  refPec: React.RefObject<HTMLInputElement> = React.createRef();

  render() {
    // destructuring state
    const {
      organizationName,
      organizationEmail,
      productsSelected,
      tierSelected,
      numberEmployees,
      subscriptionDuration,
      companyName,
      VAT,
      destinationCode,
      pec,
      name,
      email,
      surname,
      dateOfBirth,
      city,
      province,
      fiscalCode,
      address,
      phoneNumber,
      isUser,
    } = this.state;
    // destructuring props
    const { postSignupRequest } = this.props;

    // const sendData = (data: object) => {
    //   postSignupRequest(data);
    // };

    const validateEmail = (orgEmail: string) => {
      const regex = /^[a-z0-9.-_]+@[a-z0-9.-]+\.[a-z]{2,3}/;
      return regex.test(orgEmail);
    };

    const validateForm = () => {
      const errors: { [key: string]: string } = {};

      if (!this.state.organizationName) {
        errors.organizationName = "Organization name is required.";
      }

      if (
        this.state.organizationEmail &&
        !validateEmail(this.state.organizationEmail)
      ) {
        errors.organizationEmail = "Email is not valid.";
      }

      if (!this.state.organizationEmail) {
        errors.organizationEmail = "Email is required.";
      }

      if (this.state.pec && !validateEmail(this.state.pec)) {
        errors.pec = "PEC email is not valid.";
      }

      if (!this.state.companyName) {
        errors.companyName = "Company name is required.";
      }

      if (!this.state.destinationCode && !this.state.pec) {
        errors.destinationCode =
          "Please enter either a recipient code or PEC email.";
      }

      if (!this.state.VAT) {
        errors.VAT = "VAT number is required.";
      }
      // Update errors in state
      this.setState({ errors });

      // If errors object is empty, the form is valid
      const isFormValid = Object.keys(errors).length === 0;

      // Update isFormValid state
      this.setState({ isFormValid });
      return errors;
    };

    const sendData = (data: object) => {
      const errors = validateForm(); // Restituisce un oggetto con errori
      // If there are errors, show the popup
      if (Object.keys(errors).length > 0) {
        this.setState({ errors, showPopup: true });
      } else {
        const payload = {
          organizationName: this.state.organizationName,
          organizationEmail: this.state.organizationEmail,
          productsSelected: this.state.productsSelected,
          tierSelected: this.state.tierSelected.value,
          numberEmployees: this.state.numberEmployees,
          subscriptionDuration: this.state.subscriptionDuration.value,
          companyName: this.state.companyName,
          VAT: this.state.VAT,
          destinationCode: this.state.destinationCode,
          pec: this.state.pec,
        };
        // No errors, hide popup and send data
        this.setState({ errors: {}, showPopup: false });
        this.setState({ isLoading: true });
        postSignupRequest(payload);
      }
    };

    const handleSaveClick = () => {
      const isFormValid = validateForm(); // Controlla se ci sono errori
      if (!isFormValid) {
        this.setState({ showPopup: true }); // Show popup if there are errors
      } else {
        this.setState({ showPopup: false }); // Close popup if there are no errors
        sendData(this.state); // Send data if form is valid
      }
    };

    const organizationChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ organizationName: data.target.value });
    };
    const emailChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ organizationEmail: data.target.value });
    };
    const productsChange = (data: SelectOptions[]) => {
      if (data !== undefined && data.length > 0) {
        this.setState({ productsSelected: data });
      }
    };
    const tierChange = (data: SelectOptions) => {
      this.setState({ tierSelected: data });
    };
    const userChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ numberEmployees: Number(data.target.value) });
    };

    const storeChange = (data: SelectOptions) => {
      this.setState({ subscriptionDuration: data });
    };

    const companyNameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ companyName: data.target.value });
    };

    const VATChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      validateForm();
      this.setState({ VAT: data.target.value });
    };

    const nameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ name: data.target.value });
    };

    // const VATChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    //   const vat = data.target.value;
    //   this.setState({ VAT: vat, isVATValid: validateVAT(vat) }, updateFormValidity);
    // };

    const destinationCodeChange = (
      data: React.ChangeEvent<HTMLInputElement>
    ) => {
      this.setState({ destinationCode: data.target.value });
    };

    const pecChange = (data: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ pec: data.target.value || "" });
    };

    return (
      <MainLayout>
        {this.state.isLoading && <Loader isLoading={this.state.isLoading} />}
        <div className="w-full my-8 ml-auto">
          <section data-test="signup-wrapper">
            <div className="p-2 md:p-10 w-full box-border flex flex-row flex-wrap justify-center">
              <div className="login-wrapper ">
                <article>
                  <div className="loginbox shadow-sm grow">
                    <div className="login-left bg-white bg-opacity-50">
                      <img
                        className="img-fluid"
                        src={nexumLogo}
                        alt="nexumLogo"
                      />
                    </div>
                    <div className="login-right">
                      <div className="login-right-wrap">
                        {/* <h1>Registrazione</h1> */}
                        <h1>Register</h1>
                        <p className="account-subtitle">Registration</p>
                        {this.state.showPopup && (
                          <div className="popup-overlay">
                            <div className="popup">
                              <h2>Form Error</h2>
                              <ul>
                                {Object.keys(this.state.errors).map((key) => (
                                  <li key={key}>{this.state.errors[key]}</li>
                                ))}
                              </ul>
                              <button
                                onClick={() =>
                                  this.setState({ showPopup: false })
                                }
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        )}
                        <form>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="organization-name"
                              name="organization-name"
                              id="signup-organization"
                              type="text"
                              Icon={Building2Icon}
                              label="Organization Name:"
                              value={organizationName}
                              ref={this.refOrganization}
                              title="Enter organization name"
                              required
                              onChangeHandler={organizationChange}
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="email"
                              name="email"
                              id="signup-email"
                              Icon={MailIcon}
                              type="email"
                              label="Email:"
                              value={organizationEmail}
                              ref={this.refEmail}
                              title="Enter a valid email"
                              pattern={
                                /^[a-z0-9.-_]+@[a-z0-9.-]+\.[a-z]{2,3}/.source
                              }
                              required
                              onChangeHandler={emailChange}
                              className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="Company Name"
                              name="company-name"
                              id="signup-company-name"
                              type="text"
                              Icon={LucideBuilding}
                              label="Company Name:"
                              value={companyName}
                              ref={this.refCompanyName}
                              title="Enter company name"
                              required
                              onChangeHandler={companyNameChange}
                              className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="Recipient Code"
                              name="destination-code"
                              id="signup-destinationCode"
                              type="text"
                              Icon={CodeIcon}
                              label="Recipient Code:"
                              value={destinationCode}
                              ref={this.refDestinationCode}
                              title="Enter recipient code"
                              onChangeHandler={destinationCodeChange}
                              className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="pec"
                              name="pec"
                              id="signup-pec"
                              type="text"
                              Icon={MailIcon}
                              label="Pec:"
                              value={pec}
                              ref={this.refPec}
                              required={false}
                              onChangeHandler={pecChange}
                              // pattern={/^[a-z0-9.-_]+@[a-z0-9.-]+\.[a-z]{2,3}/.source}
                              title="Enter a valid PEC email (must end with .it)"
                              className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>
                          <div className="form-group">
                            <InputFieldComponent
                              data-test="VAT"
                              name="VAT"
                              id="signup-VAT"
                              type="text"
                              Icon={Combine}
                              label="VAT Number:"
                              value={VAT}
                              ref={this.refVAT}
                              // pattern={/^([0-9]{11}|[A-Z]{6}[0-9]{2}[A-Z]{1}[0-9]
                              // {2}[A-Z]{1}[0-9]{3}[A-Z]{1})$/.source}
                              title="Enter a valid VAT number"
                              required
                              onChangeHandler={VATChange}
                              className="w-full p-3 border mb-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>
                          <div
                            className="form-group"
                            style={{ display: "none" }}
                          >
                            <InputMultiSelectComponent
                              id="signup-product"
                              label="Prodotto:"
                              options={this.state.products}
                              value={productsSelected}
                              isSingleSelect={false}
                              placeholder="Select a product"
                              required
                              onMultiSelectChangeHandler={productsChange}
                            />
                          </div>
                          <div
                            className="form-group"
                            style={{ display: "none" }}
                          >
                            <InputMultiSelectComponent
                              id="signup-tier"
                              label="Version:"
                              options={[
                                { id: "1", value: "Basic" },
                                { id: "2", value: "Pro" },
                                { id: "3", value: "Enterprise" },
                              ]}
                              value={tierSelected}
                              placeholder="Select a version"
                              isSingleSelect
                              required
                              onSelectChangeHandler={tierChange}
                            />
                          </div>
                          <div
                            className="form-group"
                            style={{ display: "none" }}
                          >
                            <InputFieldComponent
                              data-test="number-user"
                              name="numberOfUsers"
                              id="signup-user"
                              type="text"
                              Icon={UsersIcon}
                              label="Number of Users:"
                              value={numberEmployees}
                              ref={this.refUser}
                              required={false}
                              title="Enter number of users"
                              onChangeHandler={userChange}
                              className="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                            />
                          </div>
                          <div
                            className="form-group"
                            style={{ display: "none" }}
                          >
                            <InputMultiSelectComponent
                              id="signup-store"
                              label="Plan:"
                              options={[
                                { id: "1", value: "Monthly" },
                                { id: "2", value: "Annual" },
                              ]}
                              placeholder="Select a plan"
                              value={subscriptionDuration}
                              required
                              onSelectChangeHandler={storeChange}
                              isSingleSelect
                            />
                          </div>
                          {/* An example to pass a ref to child and set the event */}
                          <div className="form-group">
                            <Button2
                              title="Save"
                              icon={SaveIcon}
                              className="w-full min-h-14"
                              onClick={() => {
                                handleSaveClick();
                              }}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </section>
        </div>
      </MainLayout>
    );
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  postSignupRequest: (payload: object) => {
    dispatch(actions.postSignUpRequest(payload));
  },
});
const mapStateToProps = (state: MapStateToPropsSignup) => ({
  isSignupOk: state.signupReducer.isSignupOk,
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
